$(function() {

  $('#searchArticles').keyup(function() {searchArticles()});

  $('.product-select a').click(function() {
    $('#searchArticles').val($(this).data('value'));
    searchArticles();
  });

  $('#clearSearch').on('click', function() {
    $('#searchArticles').val('');
    searchArticles();
  });

  $('button.load-more').on('click', function() {
    $('#articleList').addClass('expanded');
    $(this).hide();
  });

  function searchArticles() {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("searchArticles");
    filter = input.value.toUpperCase();
    ul = document.getElementById("articleList");
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("a")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
        } else {
            li[i].style.display = "none";
        }
    }
  }

})();